import { addLogToReport } from '@americanexpress/one-app-ducks';
import { HEADER_PWB_JWT_TOKEN, HEADER_TRACKING_ID, VRP_DASHBOARD_DELETE_PATH } from '../constants/apiConstants';
import { getClientContext } from '../utils/deviceUtils';

const DELETE_CONSENT_REQUEST = 'vrp-dashboard/DELETE_CONSENT_REQUEST';
const DELETE_CONSENT_SUCCESS = 'vrp-dashboard/DELETE_CONSENT_SUCCESS';
const DELETE_CONSENT_FAILURE = 'vrp-dashboard/DELETE_CONSENT_FAILURE';

const buildDeleteConsentRequest = (trackingId, xPwbJwtToken) => ({
  method: 'DELETE',
  credentials: 'include',
  headers: {
    ...trackingId ? { [HEADER_TRACKING_ID]: trackingId } : {},
    ...xPwbJwtToken ? { [HEADER_PWB_JWT_TOKEN]: xPwbJwtToken } : {},
  },
});

const handleDeleteHttpError = (response, body, { dispatch }) => {
  const message = body?.status_message
    || body?.message
    || 'Cancellation of consent was unsuccessful. Please try again later';
  dispatch(addLogToReport('info', 'Delete request failed', {
    moduleID: 'axp-bank-permissions-dashboard-root',
    type: DELETE_CONSENT_FAILURE,
    trackingId: response.headers?.get(HEADER_TRACKING_ID),
    status: response.status,
    response,
    ...getClientContext(),
  }));
  dispatch({ type: DELETE_CONSENT_FAILURE, payload: message, httpStatus: response.status });
  return { ok: false, status: response.status, message };
};

export const deleteConsent = ({
  apiUrl, consentId, trackingId, xPwbJwtToken, fetchClient,
}) => async (dispatch) => {
  dispatch({ type: DELETE_CONSENT_REQUEST });

  try {
    const request = buildDeleteConsentRequest(trackingId, xPwbJwtToken);
    const response = await fetchClient(`${apiUrl}${VRP_DASHBOARD_DELETE_PATH}/${consentId}`, request);

    let body = null;
    try {
      body = await response.json();
    } catch {
      body = null;
    }
    if (!response.ok) {
      return handleDeleteHttpError(response, body, { dispatch });
    }
    const updatedXPwbJwtToken = response.headers?.get(HEADER_PWB_JWT_TOKEN);
    const updatedTrackingId = response.headers?.get(HEADER_TRACKING_ID);

    dispatch(addLogToReport('info', 'Delete request success', {
      moduleID: 'axp-bank-permissions-dashboard-root',
      type: DELETE_CONSENT_SUCCESS,
      trackingId: updatedTrackingId || trackingId,
      PWB_JWT_TOKEN: updatedXPwbJwtToken || xPwbJwtToken,
      status: response.status,
      response,
      ...getClientContext(),
    }));
    dispatch({
      type: DELETE_CONSENT_SUCCESS,
      payload: {
        status: response.status,
        body,
        trackingId: updatedTrackingId || trackingId,
        xPwbJwtToken: updatedXPwbJwtToken || xPwbJwtToken,
      },
    });
    return {
      ok: true, status: response.status, body, xPwbJwtToken: updatedXPwbJwtToken || xPwbJwtToken,
    };
  } catch (error) {
    const message = error?.message || 'Cancellation of consent was unsuccessful. Please try again later';
    dispatch(addLogToReport('info', 'Delete request failed', {
      moduleID: 'axp-bank-permissions-dashboard-root',
      type: DELETE_CONSENT_FAILURE,
      trackingId: error?.headers?.get(HEADER_TRACKING_ID),
      status: error.status,
      error,
      ...getClientContext(),
    }));
    dispatch({ type: DELETE_CONSENT_FAILURE, payload: message });
    return { ok: false, status: null, message };
  }
};

export {
  DELETE_CONSENT_REQUEST,
  DELETE_CONSENT_SUCCESS,
  DELETE_CONSENT_FAILURE,
};
